
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import {
  repairLimit,
  getBranchList,
  addBranch,
  editBranch,
  delBranch,
  getBranchServicerList,
  getServicerQrCode,
  delBranchServicer,
  getBranchAdmin,
  addBracnhAdmin,
  exportBranchInviteQr,
  addBrnachServicer,
  getServicerList,
  delBrnachServicer,
  exportBranchCyclcheckQr,
  getSyncBranchCompanyBrand,
  batchDeleteRepairTemplate
} from '../../api/branch';
import { lAreaData } from '@/const/LAreaData';
import { UserModule } from '../../store/modules/user';
import html2canvas from 'html2canvas';
import { regular } from '@/const/regular';
import dialogBranchOperation from './components/BranchAdd.vue';
import { getCompanyInfo } from '../../api/company';
import { makeKey } from '@/utils/qiniu';
import { getQiniuToken } from '../../api/third';
import { Qiniu } from '@/types/qiniu';

import dialogSetImport from '../../views/staff/components/setImport.vue';
import { checkPermissionUseAndCompany } from '@/utils/permission';
import { Type } from '@/types/permissionType';

var QRCode = require('qrcode');

@Component({
  name: 'BranchAll',
  components: {
    dialogBranchOperation,
    dialogSetImport
  }
})
export default class extends Vue {
  private lAreaData!: any;
  private searchName: string = '';
  private listQuery: any = {
    page: 1,
    size: 10,
    name: '',
    // branchSelected: [],
    checkedModule: []
  };
  @Watch('listQuery', {
    deep: true
  })handleChangeQuery() {
    this.getBranchList();
  }
  private resetListQuery() {
    this.listQuery = {
      page: 1,
      size: 10,
      name: '',
      // branchSelected: [],
      checkedModule: []
    };
  }
  private listData: any = {
    list: [],
    total: 0,
    branchCount: 0
  };

  // private importUrl:BranchIndexController.import
  // private adminUrl:BranchIndexController.admin
  // private getAdmin:BranchIndexController.getAdmin
  // private companyLevel:BranchIndexController.companyLevel

  private areaIdArr: any = [];
  private defaultProps: any = {
    children: 'child',
    label: 'name',
    value: 'id'
  };

  private current: any = null;

  private addBranchVisible = false;
  private addBranchForm: any = {
    company_pid: 0,
    company_pids: '',
    company_level: 2,
    name: '',
    manager: '',
    mobile: '',
    phone_num: '',
    province: 0,
    province_name: '',
    city: 0,
    city_name: '',
    district: 0,
    district_name: '',
    address: '',
    certificate_img: ''
  };

  private resetAddBranchFromData() {
    this.areaIdArr = [];
    this.addBranchForm = {
      company_pid: 0,
      company_pids: '',
      name: '',
      manager: '',
      mobile: '',
      phone_num: '',
      province: 0,
      province_name: '',
      city: 0,
      city_name: '',
      district: 0,
      district_name: '',
      address: '',
      certificate_img: ''
    };
  }

  private editBranchVisible = false;
  private editBranchForm = {
    id: 0,
    name: '',
    manager: '',
    mobile: '',
    phone_num: '',
    province: 0,
    province_name: '',
    city: 0,
    city_name: '',
    district: 0,
    district_name: '',
    address: '',
    certificate_img: ''
  };

  private resetEditBranchFormData() {
    this.areaIdArr = [];
    this.editBranchForm = {
      id: 0,
      name: '',
      manager: '',
      mobile: '',
      phone_num: '',
      province: 0,
      province_name: '',
      city: 0,
      city_name: '',
      district: 0,
      district_name: '',
      address: '',
      certificate_img: ''
    };
  }
  private regular = regular;
  private rules = {
    name: [
      {
        required: true,
        message: '请输入2-30位由字母、数字、中文、小括号组成的公司名称',
        trigger: 'blur'
      },
      {
        pattern: regular.companyName.pattern,
        message: '请输入2-30位由字母、数字、中文、小括号组成的公司名称',
        trigger: 'blur'
      }
    ],
    username: [
      {
        required: true,
        message: '请输入2-10位由字母、中文组成的姓名',
        trigger: 'blur'
      },
      { pattern: regular.userName.pattern, message: '请输入2-10位由字母、中文组成的姓名', trigger: 'blur' }
    ],
    manager: [
      {
        pattern: regular.userName.pattern,
        message: '请输入2-10位由字母、中文组成的姓名',
        trigger: 'blur'
      }
    ],
    mobile: [
      {
        // pattern: regular.mobile.pattern,
        message: '请输入正确格式的手机号码',
        trigger: 'blur'
      }
    ],
    adminmobile: [
      { required: true, message: '请输入正确格式的手机号码', trigger: 'blur' },
      { pattern: regular.mobile.pattern, message: '请输入正确格式的手机号码', trigger: 'blur' }
    ],
    password: [
      {
        required: true,
        message: '请输入6-30位字母、数字、_、-组成的密码',
        trigger: 'blur'
      },
      {
        // pattern: regular.password.pattern,
        message: '请输入6-30位字母、数字、_、-组成的密码',
        trigger: 'blur'
      }
    ],
    phone_num: [
      {
        // pattern: regular.phone.pattern,
        message: '请输入5-12位电话号码',
        trigger: 'blur'
      }
    ],
    address: [
      {
        // pattern: regular.address.pattern,
        message: '请输入2-50个字符组成的地址',
        trigger: 'blur'
      }
    ],
    email: [
      {
        // pattern: regular.email.pattern,
        message: '请输入正确格式的邮箱',
        trigger: 'blur'
      }
    ]
  }

  private maxLevel = 4;
  private loading = false;
  private disabled = false;
  private qiniu: any;
  private action = 'https://up-z1.qiniup.com';
  private certificateImg = '';
  private form: object = {};
  private imgLargePath = '';

  private deviceListVisible = false;

  private selectedAll = false;
  private isIndeterminate: any = null;
  private branchSelected: any = [];
  private branchSelectedLength = 0;

  private dialogGroupSyncVisible = false;
  private checkedModule = [];
  private modules = [];

  // private showButton: any = {
  //   sync: false,
  //   addMyServicer: false,
  //   addServicer: false
  // };

  private dialogManagerVisible = false;
  private managerForm: any = {
    mobile: '',
    name: '',
    password: '',
    email: '',
    is_have: ''
  };

  private addServicerVisible = false;
  private addServicerVisibleLoading=false;
  private addServicerForm: any = {
    onlyid: '',
    remark: ''
  };

  private servicerQuery: any = {
    company_id: 0,
    page: 1
  };

  private servicerList = [];
  private servicerListVisible = false;
  private servicerMore = false;
  private servicerMoreLoading = false;
  private servicerQrcodeVisible = false;
  private servicerQrcodeStr = '';
  private servicerQrcodeHref = '';
  private servicerSelected = '';

  private inviteQrVisible = false;
  private inviteQrItem = [];
  private vipLev=1;
  private TemplateDIY=false;

  created() {
    if (UserModule.getCompany && UserModule.getCompany.vip_level) {
      this.vipLev = parseInt(UserModule.getCompany.vip_level.substr(0, 1));
    }
    this.TemplateDIY = checkPermissionUseAndCompany(UserModule.getCompanyId, Type.TemplateDIY);
    this.lAreaData = lAreaData;
    this.lAreaData.map((item: any) => {
      if (!item || !item.child || item.child.length === 0) {
        (item.child as any) = undefined;
      } else {
        item.child.map((temp: any) => {
          if (!temp || !temp.child || temp.child.length === 0) {
            (temp.child as any) = undefined;
          }
        });
      }
    });
    const params = {
      type: Qiniu.UPLOAD_TYPE_COMPANY
    };
    getQiniuToken(params).then(res => {
      if (res && res.data) {
        this.qiniu = res.data;
      }
    });
    this.resetListQuery();
  }
  private handleSizeChange(val:number) {
    this.listQuery.size = val;
  }
  private handleCurrentChange(val:number) {
    this.listQuery.page = val;
  }
  private getBranchList() {
    this.branchSelected = [];
    this.selectedAll = false;
    this.isIndeterminate = null;
    this.branchSelectedLength = 0;
    this.loading = true;
    let params = {
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      user_id: UserModule.getUserId,
      name: this.listQuery.name,
      page: this.listQuery.page,
      size: this.listQuery.size
    };
    getBranchList(params)
      .then(res => {
        this.loading = false;
        if (res && res.data) {
          this.listData = res.data;
          this.listData.total = res.data.count || 0;
        } else {
          this.listData = {
            total: 0,
            list: [],
            branchCount: 0
          };
        }
      })
      .catch(err => {
        this.loading = false;
        let msg = err.msg;
      });
  }
  private search() {
    this.listQuery.name = this.searchName;
  }
  private clear() {
    this.searchName = '';
    this.listQuery.name = '';
  }

  private areaChange(val: any) {
    const labels = (this.$refs['cascader'] as any).getCheckedNodes()[0]
      .pathLabels;
    this.addBranchForm.province = val[0] || 0;
    this.addBranchForm.province_name = labels[0] || '';
    this.addBranchForm.city = val[1] || 0;
    this.addBranchForm.city_name = labels[1] || '';
    this.addBranchForm.district = val[2] || 0;
    this.addBranchForm.district_name = labels[2] || '';
    this.editBranchForm.province = val[0] || 0;
    this.editBranchForm.province_name = labels[0] || '';
    this.editBranchForm.city = val[1] || 0;
    this.editBranchForm.city_name = labels[1] || '';
    this.editBranchForm.district = val[2] || 0;
    this.editBranchForm.district_name = labels[2] || '';
  }

  private uploadSuccess(res: any) {
    const imgUrl = this.qiniu.default_url + res.key;
    this.certificateImg = imgUrl;
    this.addBranchForm.certificate_img = res.key;
    this.editBranchForm.certificate_img = res.key;
  }

  private beforeUpload(file:any) {
    const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
    const isLt2M = file.size / 1024 / 1024 < 5;
    if (!isJPG) {
      return this.$message.error('上传文件只能是  JPG或PNG 格式!');
    }
    if (!isLt2M) {
      return this.$message.error('上传图片大小不能超过 5MB!');
    }
    return new Promise((resolve, reject) => {
      resolve(true);
    }).then(res => {
      let k = makeKey(this.qiniu.prekey);
      this.form = {
        key: k,
        token: this.qiniu.uptoken,
        domain: this.qiniu.domain
      };
    });
  }

  private deleteImg() {
    this.addBranchForm.certificate_img = '';
    this.editBranchForm.certificate_img = '';
  }

  private handleCheckAllChange(val: boolean) {
    let branesOptions: any = [];

    if (val) {
      for (let i = 0; i < this.listData.list.length; i++) {
        branesOptions.push(this.listData.list[i].id);
        if (this.listData.list[i].child) {
          for (let m = 0; m < this.listData.list[i].child.length; m++) {
            branesOptions.push(this.listData.list[i].child[m].id);
            if (this.listData.list[i].child[m].child) {
              for (
                let n = 0;
                n < this.listData.list[i].child[m].child.length;
                n++
              ) {
                branesOptions.push(this.listData.list[i].child[m].child[n].id);
              }
            }
          }
        }
      }
    } else {
      branesOptions = [];
    }

    this.branchSelected = branesOptions;
    this.isIndeterminate = false;
  }

  private handleCheckedBranchChange(value: any) {
    let checkedCount = this.branchSelected.length;
    let _length = this.listData.list.length;
    for (let i = 0; i < this.listData.list.length; i++) {
      if (this.listData.list[i].child) {
        _length += this.listData.list[i].child.length;
        for (let m = 0; m < this.listData.list[i].child.length; m++) {
          if (this.listData.list[i].child[m].child) {
            _length += this.listData.list[i].child[m].child.length;
          }
        }
      }
    }

    if (this.branchSelected.length > this.branchSelectedLength) {
      this.branchSelectedLength = ++this.branchSelectedLength;
      if (value.child) {
        for (let i = 0; i < value.child.length; i++) {
          if (this.branchSelected.indexOf(value.child[i].id) === -1) {
            this.branchSelected.push(value.child[i].id);
            this.branchSelectedLength = ++this.branchSelectedLength;
          }

          if (value.child[i].child) {
            for (let m = 0; m < value.child[i].child.length; m++) {
              if (
                this.branchSelected.indexOf(value.child[i].child[m].id) === -1
              ) {
                this.branchSelected.push(value.child[i].child[m].id);
                this.branchSelectedLength = ++this.branchSelectedLength;
              }
            }
          }
        }
      }
    } else {
      this.branchSelectedLength = --this.branchSelectedLength;
    }

    this.selectedAll = (checkedCount === _length) || (this.branchSelectedLength === _length);
    this.isIndeterminate = this.branchSelectedLength > 0 && this.branchSelectedLength < _length;
    //  (checkedCount > 0 && checkedCount < _length)
  }

  private syncData() {}
  // 导入--------------------
  private branchCompanyId='0'
  private setImportVisible=false;
  private setImportTitle='导入分公司'
  private importBranch(val:any) {
    if (val) {
      this.branchCompanyId = val.id;
    }
    this.setImportVisible = true;
  }
  closeImport(value: boolean) {
    this.getBranchList();
    this.setImportVisible = value;
  }
  // --------------------------导入
  // 批量删除
  private ServicerGroupPage=1;
  private ServicerGroupSize=10;
  private ServicerGroupPageCount=1;
  private deleteServicerVisible=false;
  private branchServicerIsIndeterminate=false;
  private branchServicerselectedAll='';
  private branchServicerSelected:any=[];
  private branchServicerList:any=[];
  private branchServicerSelectedLength=0;
  private branchServicerMoreLoading=false;
  private delServicerGroup(type:number) {
    if (type === 1) {
      let pamars:any = {};
      pamars.company_id = UserModule.getCompanyId;
      pamars.user_id = UserModule.getUserId;
      pamars.branch_company_ids = this.branchSelected;
      pamars.page = this.ServicerGroupPage;
      pamars.size = this.ServicerGroupSize;
      getServicerList(pamars).then((res:any) => {
        this.ServicerGroupPageCount = res.page_count;
        this.branchServicerList = this.branchServicerList.concat(res.data.list);
      }).catch(err => {
        let msg = err.msg;
      });
      return;
    }
    if (this.branchSelected.length === 0) {
      this.showErrorMsg('请选择分公司');
      return false;
    }
    this.branchServicerSelected = [];
    this.branchServicerIsIndeterminate = false;
    this.branchServicerselectedAll = '';
    let pamars:any = {};
    pamars.company_id = UserModule.getCompanyId;
    pamars.user_id = UserModule.getUserId;
    pamars.branch_company_ids = this.branchSelected;
    pamars.page = this.ServicerGroupPage;
    pamars.size = this.ServicerGroupSize;
    getServicerList(pamars).then((res:any) => {
      this.ServicerGroupPageCount = res.page_count;
      this.branchServicerList = res.data.list;
      this.deleteServicerVisible = true;
    }).catch(err => {
      this.ServicerGroupPageCount = 1;
      this.branchServicerList = [];
      this.deleteServicerVisible = true;
      let msg = err.msg;
    });
  }
  private handleCheckAllChangeBranchServicer(val:any) {
    let branesOptions = [];
    if (val) {
      for (let i = 0; i < this.branchServicerList.length; i++) {
        branesOptions.push(this.branchServicerList[i].servicer_company_id);
      }
    }

    this.branchServicerSelected = branesOptions;
    this.branchServicerSelectedLength = branesOptions.length;
    this.branchServicerIsIndeterminate = false;
  }
  private moreBranchServicerData() {
    this.branchServicerMoreLoading = true;
    this.ServicerGroupPage += 1;
    this.delServicerGroup(1);
  }
  private confirmBatchDeleteServicer() {
    if (!this.branchServicerSelected || this.branchServicerSelected.length < 1) {
      this.showErrorMsg('请选择服务方');
      return;
    }
    const params = {
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      user_id: UserModule.getUserId,
      branch_company_ids: this.branchSelected,
      servicer_company_ids: this.branchServicerSelected
    };
    delBrnachServicer(params).then((res:any) => {
      this.showSecussMsg(res.msg);
      this.deleteServicerVisible = false;
      this.listQuery.page = 1;
      this.getBranchList();
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  // 批量添加
  private addServicerGroup() {
    if (this.branchSelected.length === 0) {
      this.showErrorMsg('请选择分公司');
      return false;
    }
    this.addServicerForm.onlyid = '';
    this.servicerSelected = '';
    this.rowId = 0;
    this.addServicerVisible = true;
  }
  private doSelectServicer() {
    if (this.servicerSelected === '') {
      this.showErrorMsg('请选择服务方');
      return false;
    }
    this.servicerListVisible = false;
    this.addServicerForm.onlyid = this.servicerSelected;
  }
  private confirmBatchAddServicer() {
    if (!this.addServicerForm.onlyid) {
      this.showErrorMsg('请输入服务方ID');
      return;
    }
    let params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      only_id: this.addServicerForm.onlyid
    };
    getCompanyInfo(params).then(res => {
      let name = res.data.name;
      this.$confirm(`确认添加${name}为服务方吗？`, '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(res => {
        this.addBranchServicer();
      }).catch(() => {
        this.addServicerVisible = false;
      });
    }).catch(err => {
      let msg = err.msg;
      this.showErrorMsg('请输入正确的唯一ID');
    });
  }
  private addBranchServicer() {
    this.addServicerVisibleLoading = true;
    const params = {
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      user_id: UserModule.getUserId,
      branch_company_id: this.branchSelected,
      only_id: this.addServicerForm.onlyid,
      remark: this.addServicerForm.remark,
      is_branch_add: 1
    };
    addBrnachServicer(params).then(res => {
      this.showSecussMsg('添加成功');
      this.addServicerVisibleLoading = false;
      this.addServicerVisible = false;
      this.listQuery.page = 1;
      this.getBranchList();
    }).catch(err => {
      this.addServicerVisibleLoading = false;
      this.showErrorMsg(err.msg);
    });
  }
  private addServicer() {}
  private btnSyncGroup() {
    if (this.branchSelected.length === 0) {
      this.showErrorMsg('请选择分公司');
      return false;
    }
    this.dialogGroupSyncVisible = true;
  }
  private exportInviteQr() {
    if (this.branchSelected.length === 0) {
      this.showErrorMsg('请选择分公司');
      return false;
    }
    this.inviteQrVisible = true;
  }
  private exportCyclcheckQr() {
    if (this.branchSelected.length === 0) {
      this.showErrorMsg('请选择分公司'); return;
    }

    let arr = [];
    for (let index = 0; index < this.branchSelected.length; index++) {
      const element:any = this.branchSelected[index];
      arr.push(element);
    }
    let pamars:any = {};
    pamars.company_id = UserModule.getCompanyId;
    pamars.company_name = UserModule.getCompanyName;
    pamars.user_id = UserModule.getUserId;
    pamars.user_name = UserModule.getUserName;
    pamars.branch_company_ids = arr.join(',');

    exportBranchCyclcheckQr(pamars).then(res => {
      this.$confirm('是否跳转下载页面？', '跳转', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let routeData = this.$router.resolve({
          path: '/ExportTask',
          query: {}
        });
        window.open(routeData.href);
      }).catch(() => {

      });
    }).catch(err => {
      let msg = err.msg;
    });
  }

  private handleCommandLimit(command: any) {
    if (command === 'open') {
      if (this.branchSelected.length > 0) {
        this.$confirm('开启后，分公司将禁止向其不在服务方列表的服务方提交订单', '确认限制分公司报修', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then((msg) => {
          this.repairLimit(1);
        }).catch((err) => {
          let msg = err;
        });
      } else {
        this.$notify({
          title: '提示',
          message: '请选择分公司',
          type: 'warning'
        });
      }
    } else if (command === 'close') {
      if (this.branchSelected.length === 0) {
        this.$notify({
          title: '提示',
          message: '请选择分公司',
          type: 'warning'
        });
        return;
      }
      this.repairLimit(0);
    }
  }
  private repairLimit(open:number) {
    let params:any = {
      company_id: UserModule.getCompanyId,
      user_id: UserModule.getUserId,
      is_repair_limit: open,
      branch_company_id: this.branchSelected.join(',')
    };

    repairLimit(params).then((res:any) => {
      this.showSecussMsg(res.msg);
      this.getBranchList();
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  private downloadInviteQr() {
    if (this.inviteQrItem.length === 0) {
      this.showErrorMsg('请选择二维码导出类型');
      return false;
    }
    const params = {
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      branch_company_id: this.branchSelected.join(','),
      item: this.inviteQrItem.join(',')
    };
    exportBranchInviteQr(params)
      .catch(err => {
        if (!err.msg) {
          let blob = new Blob([err]);
          let fileName = new Date().getTime() + '.pdf';
          if ('download' in document.createElement('a')) {
          // 非IE下载
            let elink = document.createElement('a');
            elink.download = fileName;
            elink.style.display = 'none';
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink);
          } else {
          // IE10+下载
            // navigator.msSaveBlob(blob, fileName);
          }
          this.$message.success('下载文件成功');
        } else {
          this.$message.error(err.msg);
        }
      });
  }
  private addBranch(parent?: any, child?: any) {
    this.resetAddBranchFromData();
    this.addBranchVisible = true;
    if (parent !== undefined) {
      this.addBranchForm.company_pid = parent.id;
      this.addBranchForm.company_pids = parent.company_pids;
      if (child !== undefined) {
        // 有下级，就把下级放进去
        this.addBranchForm.company_pid = child.id;
        this.addBranchForm.company_pids = [child.company_pids, child.id].join(',');
      }
    } else {
      this.addBranchForm.company_pid = null;
      this.addBranchForm.company_pids = null;
    }
  }
  private doAddBranch() {
    if (!this.addBranchForm.name) {
      this.showErrorMsg('请输入公司名称');
      return;
    }
    const params = {
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      user_id: UserModule.getUserId,
      ...this.addBranchForm
    };
    addBranch(params)
      .then(res => {
        this.showSecussMsg('添加成功');
        this.resetListQuery();
        this.addBranchVisible = false;
      })
      .catch(err => {
        this.showErrorMsg(err.msg);
      });
  }

  private importReset() {}
  private editBranch(row: any) {
    this.resetEditBranchFormData();
    this.editBranchVisible = true;
    this.editBranchForm = {
      ...row
    };
    this.areaIdArr = [row.province, row.city, row.district];
  }
  private doEditBranch() {
    const params = {
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      user_id: UserModule.getUserId,
      ...this.editBranchForm
    };
    editBranch(params)
      .then(res => {
        this.showSecussMsg('修改成功');
        this.resetListQuery();
        this.editBranchVisible = false;
      })
      .catch(err => {
        this.showErrorMsg(err.msg);
      });
  }
  private delBranch(row: any) {
    if (row.child) {
      this.showErrorMsg('该公司下有分公司，禁止删除！');
      return false;
    }
    this.$confirm('是否删除?', '', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        this.doDelBranch(row);
      })
      .catch(() => {});
  }
  private doDelBranch(row: any) {
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      id: row.id
    };
    delBranch(params)
      .then(res => {
        this.showSecussMsg('删除成功');
        this.resetListQuery();
      })
      .catch(err => {
        this.showErrorMsg(err.msg);
      });
  }
  // 服务方列表出现 点击事件
  private clickServerList(val:any) {
    this.currentServicerListPage = 1;
    if (val) {
      this.rowId = val.id;
    } else {
      this.rowId = 0;
    }
    this.getBranchServicerList();
  }
  // 取消服务方列表出现
  private cancleServerList() {
    this.servicerListVisible = false;
    this.rowId = 0;
    this.currentServicerListPage = 1;
    this.servicerList = [];
  }
  private currentServicerListPage = 1;
  private rowId=0
  private getBranchServicerList() {
    const params:any = {
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      user_id: UserModule.getUserId,
      page: this.currentServicerListPage,
      size: 10
    };
    if (this.rowId !== 0) {
      params.query_company_id = this.rowId;
    }
    getBranchServicerList(params)
      .then(res => {
        if (res && res.data) {
          if (this.currentServicerListPage === 1) {
            this.servicerList = res.data.list;
          } else {
            this.servicerList = this.servicerList.concat(res.data.list);
          }
          if (res.data.page_count > this.currentServicerListPage) {
            this.servicerMore = true;
          } else {
            this.servicerMore = false;
          }
        } else {
          this.servicerList = [];
        }
        this.servicerMoreLoading = false;
      })
      .catch(err => {
        this.showErrorMsg(err.msg);
      });
    this.servicerListVisible = true;
  }
  private moreServicerData() {
    this.currentServicerListPage = this.currentServicerListPage + 1;
    this.getBranchList();
  }
  private qrFlge = false;
  private formCode: any = {
    servicer: '',
    customer: '',
    qrCode: '',
    a: '',
    b: ''
  };
  private getServicerQrcode(row: any) {
    this.qrFlge = true;
    this.formCode.servicer =
      row.short_name !== '' ? row.short_name : row.servicer_company_name;
    this.formCode.customer =
      UserModule.getCompanyShortName !== ''
        ? UserModule.getCompanyShortName
        : UserModule.getCompanyName;
    QRCode.toDataURL(row.qr_str)
      .then((url: any) => {
        this.formCode.qrCode = url;
      })
      .catch((err: any) => {
        let msg = err;
      });
  }
  // 下载二维码
  handleDownload() {
    let code = document.querySelector('#qrCodeServiceid');
    let filename = '';
    html2canvas(code as any).then(function(canvas: any) {
      let image = new Image();
      image.src = canvas.toDataURL('image/png');
      let a = document.createElement('a');
      a.appendChild(image);
      a.href = image.src;
      a.download = filename;
      a.click();
    });
  }
  private deleteServicer(row: any) {
    this.$confirm('是否删除?', '', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        this.doDelBranchServicer(row);
      })
      .catch(() => {});
  }
  private doDelBranchServicer(row: any) {
    // TODO: 接口问题
    const params = {
      user_id: UserModule.getUserId,
      company_id: row.company_id,
      // user_name: UserModule.getUserName,
      // company_name: UserModule.getCompanyName,
      relation_id: row.sid
    };
    delBranchServicer(params)
      .then(res => {
        this.getBranchServicerList();
      })
      .catch(err => {
        this.showErrorMsg(err.msg);
      });
  }
  private selectServicer() {
    this.servicerListVisible = false;
  }
  private addAdmin(row: any) {
    this.managerForm = {
      mobile: '',
      name: '',
      password: '',
      email: '',
      is_have: ''
    };
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      id: row.id
    };
    getBranchAdmin(params)
      .then(res => {
        if (res && res.data) {
          this.managerForm.mobile = res.data.account.mobile;
          this.managerForm.name = res.data.user.name;
          this.managerForm.email = res.data.user.email;
          this.managerForm.is_have = 1;
        } else {
          this.managerForm.is_have = 0;
        }

        this.dialogManagerVisible = true;
        this.current = row;
      })
      .catch(err => {
        this.showErrorMsg(err.msg);
      });
  }
  private addAdminSubmit() {
    if (!this.managerForm.mobile) {
      this.showErrorMsg('请输入手机号');
      return;
    }
    if (this.managerForm.mobile.substring(0, 1) !== '1' || this.managerForm.mobile.length !== 11) {
      this.showErrorMsg('请输入正确格式的手机号');
      return;
    }
    if (!this.managerForm.password) {
      this.showErrorMsg('请输入密码');
      return;
    }
    if (this.managerForm.password.length < 6 || this.managerForm.password.length > 30) {
      this.showErrorMsg('请输入6-30位字母、数字、_、-组成的密码');
      return;
    }
    if (!this.managerForm.name) {
      this.showErrorMsg('请输入姓名');
      return;
    }
    if (this.managerForm.name.length < 2 || this.managerForm.name.length > 10) {
      this.showErrorMsg('请输入2-10位由字母、中文组成的姓名');
      return;
    }
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      id: this.current.id,
      ...this.managerForm
    };
    addBracnhAdmin(params)
      .then(res => {
        this.showSecussMsg('操作成功');
        this.dialogManagerVisible = false;
      })
      .catch(err => {
        this.showErrorMsg(err.msg);
      });
  }

  // 批量设置报修样式
  private settingStyle() {
    // 跳转 设置报修样式页
    if (this.branchSelected.length === 0) {
      this.showErrorMsg('请选择分公司');
      return false;
    }
    let ids = this.branchSelected.join(',');
    this.$router.push({
      path: '/System/template',
      query: { 'branch_company_ids': ids, 'activeName': 'template' }
    });
  }
  private cancleStyle() {
    if (!this.branchSelected || this.branchSelected.length === 0) {
      this.showErrorMsg('请选择分公司');
      return false;
    }
    this.$confirm('是否取消报修样式?', '', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      let ids = this.branchSelected.join(',');
      let params: any = {};
      params.user_id = UserModule.getUserId;
      params.company_id = UserModule.getCompanyId;
      params.order_first_step = 6;
      params.branch_company_ids = ids
      batchDeleteRepairTemplate(params).then((res:any) => {
        this.showSecussMsg(res.msg)
        this.getBranchList()
      }).catch(err => {
        this.showErrorMsg(err.msg)
      })
    })
      .catch(() => {});
  }

  // 报修方批量同步
  private groupBrand() {
    if (this.branchSelected.length === 0) {
      this.showErrorMsg('请选择分公司');
      return false;
    }
    this.$confirm('产品品牌同步会将本公司的所有品牌同步至分公司中，且分公司无法修改，是否继续同步？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      this.getSyncBranchCompanyBrand();
    }).catch(() => {

    });
  }
  private getSyncBranchCompanyBrand() {
    let ids = this.branchSelected.join(',');
    let pamars:any = {};
    pamars.user_id = UserModule.getUserId;
    pamars.company_id = UserModule.getCompanyId;
    pamars.branch_company_ids = ids;
    getSyncBranchCompanyBrand(pamars).then(res => {
      this.$confirm('跳转', '跳转', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let routeData = this.$router.resolve({
            path: '/ImportTask',
            query: {}
          });
          window.open(routeData.href);
        })
        .catch(() => {});
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }

  private customHeight = window.innerHeight * 0.4;
  private showErrorMsg(msg: string, title ?: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: this.customHeight,
      customClass: 'notification-center',
      type: 'success'
    });
  }

  private dialogBranchOperationVisible = false;
  private titleBranchOperation = '添加分公司';
  private branchForm: any = {};
  private closeBranchHandle(value: boolean) {
    this.dialogBranchOperationVisible = value;
  }
}
